<span class="citation-group">
  <!-- First citation always visible -->
  <app-citation-link
    *ngIf="firstCitation"
    [citationNumber]="firstCitation.number"
    [tooltipText]="firstCitation.tooltipText"
    [isAvailable]="firstCitation.isAvailable"
    (citationClick)="onCitationClick($event)">
  </app-citation-link>

  <!-- Collapsed view: Show ellipsis button -->
  <button
    *ngIf="!isExpanded"
    class="citation-control-button ellipsis-button"
    [matTooltip]="ellipsisTooltip"
    aria-label="ellipsisTooltip"
    (click)="toggleExpanded()"
    type="button">
    ...
  </button>

  <!-- Expanded view: Show collapse button and remaining citations -->
  <ng-container *ngIf="isExpanded">
    <button
      class="citation-control-button collapse-button"
      matTooltip="Collapse citations"
      aria-label="Collapse citations"
      (click)="toggleExpanded()"
      type="button">
      ><
    </button>

    <app-citation-link
      *ngFor="let citation of remainingCitations"
      [citationNumber]="citation.number"
      [tooltipText]="citation.tooltipText"
      [isAvailable]="citation.isAvailable"
      (citationClick)="onCitationClick($event)">
    </app-citation-link>
  </ng-container>
</span>
